"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Identifiers for validation types on mappings.
 */
var FieldValidationTypes;
(function (FieldValidationTypes) {
    FieldValidationTypes["STRING_MIN"] = "S-EMIN";
    FieldValidationTypes["STRING_MAX"] = "S-EMAX";
    FieldValidationTypes["STRING_NOT"] = "S-NOT";
    FieldValidationTypes["NUMBER_MAX"] = "N-EMAX";
    FieldValidationTypes["NUMBER_MIN"] = "N-EMIN";
    FieldValidationTypes["NUMBER_NOT"] = "N-NOT";
    FieldValidationTypes["ARRAY_MAX"] = "A-EMAX";
    FieldValidationTypes["ARRAY_MIN"] = "A-EMIN";
    FieldValidationTypes["ARRAY_NOT"] = "A-NOT";
    FieldValidationTypes["OBJECT_NOT"] = "O-NOT";
    FieldValidationTypes["BOOLEAN_NOT"] = "B-NOT";
    FieldValidationTypes["MODEL_NOT"] = "M-NOT";
    FieldValidationTypes["REQUIRED"] = "REQ";
    FieldValidationTypes["REGEX"] = "S-REG";
    FieldValidationTypes["DATE_NOT"] = "DATE-NOT";
    FieldValidationTypes["DATE"] = "DATE-INVALID";
    FieldValidationTypes["DATE_MIN"] = "DATE-MIN";
    FieldValidationTypes["DATE_MAX"] = "DATE-MAX";
})(FieldValidationTypes = exports.FieldValidationTypes || (exports.FieldValidationTypes = {}));
